import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import intl from 'react-intl-universal';
import { Input as TextInput } from '@lifesize/clients.mui-components';
import useForm from 'hooks/useForm';
import { MainContext } from 'context';

type ValidationError = {
  name: string;
  message: string;
};

type CallMeDirectlyFormState = {
  name?: string;
  error?: ValidationError;
};

const CallMeDirectly = () => {
  const classes = userFieldStyles();

  const { setOneTimeName, oneTimeName } = useContext(MainContext);
  const [state, setState, , error] = useForm<CallMeDirectlyFormState>({ name: oneTimeName });
  return (
    <>
      <Box className={classes.userDetails}>
        <>
          <Box mt={2} width={'100%'} data-testid="call-me-directly">
            <TextInput
              className={classes.formField}
              inputProps={{ maxLength: 32 }}
              label={intl.get('meetingNameInputLabel')}
              helperText={error.get('name')}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const value: string = event.target.value.trimStart();
                setState({
                  ...state,
                  name: value
                });
              }}
              variant="outlined"
              value={state.name}
              onBlur={() => setOneTimeName && setOneTimeName(state.name as string)}
            />
          </Box>
        </>
      </Box>
    </>
  );
};

const userFieldStyles = makeStyles(() => ({
  userDetails: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '100%',
    width: '100%'
  },
  formField: {
    maxWidth: '500px',
    width: '100%'
  }
}));

export default CallMeDirectly;
